import { Link } from "react-router-dom";
import logoLight from "@/assets/brand/lux-logo.png";
import logoDark from "@/assets/brand/lux-logo-dark.png";
import hornsSharp from "@/assets/brand/lux-horns.png";
import hornsGlow from "@/assets/brand/lux-horns-glow.png";

/**
 * Official LUX logo (bold wordmark, horns on the X) supplied by the owner.
 * `tone="light"` is the off-white ink for dark surfaces; `tone="dark"` for light surfaces (staff console).
 * `size` accepts the legacy text-size classes used across the app or a Tailwind height class.
 * `glow` adds the hover effect: the horn tips brighten and breathe softly (pre-rendered layers, opacity-only animation).
 */
const SIZE_MAP = {
  "text-xl": "h-7",
  "text-2xl": "h-8",
  "text-[26px]": "h-9",
  "text-3xl": "h-10",
  "text-4xl": "h-12",
  "text-5xl": "h-16",
};

export default function Wordmark({ className = "", size = "text-2xl", to = "/", tone = "light", glow = false, testId = "public-header-wordmark" }) {
  const h = SIZE_MAP[size] || (size.startsWith("h-") ? size : "h-8");
  const base = (
    <img
      src={tone === "dark" ? logoDark : logoLight}
      alt="LUX"
      className={`${h} w-auto select-none ${className}`}
      draggable="false"
      decoding="async"
      data-testid="lux-wordmark"
    />
  );
  const mark = glow && tone === "light" ? (
    <span className="lux-logo relative inline-block" data-testid="lux-wordmark-glow-wrapper">
      {base}
      <img src={hornsGlow} alt="" aria-hidden="true" className="lux-logo-glow pointer-events-none absolute inset-0 h-full w-full select-none" draggable="false" decoding="async" />
      <img src={hornsSharp} alt="" aria-hidden="true" className="lux-logo-horns pointer-events-none absolute inset-0 h-full w-full select-none" draggable="false" decoding="async" />
    </span>
  ) : base;
  if (!to) return mark;
  return (
    <Link to={to} aria-label="LUX home" data-testid={testId} className="group inline-flex items-center rounded-md">
      {mark}
    </Link>
  );
}
